module.exports = __webpack_public_path__ + "img/phone-call.999a00e1.svg";